import { React } from "react";
import Main from "./components/Main";
import JoinUs from "./components/JoinUs";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import AboutUs from "./components/AboutUs";
import { LangProvider } from './components/Language/LangContext';

function App() { 

  return (
    <LangProvider>
    <div className="pt-10">
      <div className="pb:20">
        <Router>
          <Routes>
            <Route path="/" element={<Main />}  />
            <Route path="/joinUs" element={<JoinUs />} exact/>
            {/* <Route path="/AboutUs" element={<AboutUs />} exact /> */}
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} exact/>
          </Routes>
        </Router>
      </div>  
    </div>
    </LangProvider>

  );
  
}
export default App;

